// "INSTALAR O ADVUP" (06/10/2026).
//
// No Android o Chrome avisa (`beforeinstallprompt`) que o app pode ser
// instalado — e ninguém escutava: a instalação ficava escondida no menu ⋮
// do navegador. No iPhone não existe esse aviso; a instalação é pelo menu
// Compartilhar → "Adicionar à Tela de Início", e é ela que destrava as
// notificações (o iOS só manda push para app instalado).
//
// `ouvirInstalacao()` roda uma vez, cedo, no início do app (o aviso do Chrome
// chega logo no carregamento); `useInstalarApp()` diz se dá para oferecer e
// de que jeito.
import { computed, ref } from 'vue';

const avisoGuardado = ref(null);
const instaladoAgora = ref(false);
let ouvindo = false;

export const estaInstalado = () =>
  typeof window !== 'undefined' &&
  (window.matchMedia?.('(display-mode: standalone)').matches ||
    window.navigator.standalone === true);

export const ehIphoneOuIpad = (nav = window.navigator) =>
  /iphone|ipad|ipod/i.test(nav.userAgent) ||
  // iPad com iPadOS se apresenta como Mac — mas Mac não tem toque
  (nav.platform === 'MacIntel' && nav.maxTouchPoints > 1);

export const ouvirInstalacao = () => {
  if (ouvindo || typeof window === 'undefined') return;
  ouvindo = true;
  window.addEventListener('beforeinstallprompt', evento => {
    evento.preventDefault();
    avisoGuardado.value = evento;
  });
  window.addEventListener('appinstalled', () => {
    instaladoAgora.value = true;
    avisoGuardado.value = null;
  });
};

export const useInstalarApp = () => {
  const modo = computed(() => {
    if (instaladoAgora.value || estaInstalado()) return null;
    if (avisoGuardado.value) return 'nativo';
    if (ehIphoneOuIpad()) return 'iphone';
    return null;
  });

  const instalar = async () => {
    const aviso = avisoGuardado.value;
    if (!aviso) return false;
    aviso.prompt();
    const { outcome } = await aviso.userChoice;
    avisoGuardado.value = null;
    if (outcome === 'accepted') instaladoAgora.value = true;
    return outcome === 'accepted';
  };

  return { modo, instalar };
};

// Só para os testes.
export const reiniciarInstalacao = () => {
  avisoGuardado.value = null;
  instaladoAgora.value = false;
};
